import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const HeartLiked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 6c3.314 0 6 2.719 6 6.073a6.09 6.09 0 01-2.106 4.62L16 25.8l-8.878-9.093A6.09 6.09 0 015 12.073C5 8.719 7.686 6 11 6a5.976 5.976 0 015 2.715A5.973 5.973 0 0121 6z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)
